import imgPersonal from "../Images/service.jpg";
import imgCompanion from "../Images/service1.jpg";
import imgDementia from "../Images/service3.jpg";
import imgLife from "../Images/service2.jpg";

import {
  faHandHoldingHeart,
  faPeopleGroup,
  faBrain,
  faHeartPulse,
  faBath,
  faPills,
  faShirt,
  faUtensils,
  faCarSide,
  faBroom,
  faMugHot,
  faPuzzlePiece,
  faShieldHalved,
  faHouseUser,
  faListCheck,
  faBagShopping,
  faPersonWalking,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

// Rich content for each service detail page.
export const SERVICES = [
  {
    slug: "personal-care-services",
    icon: faHandHoldingHeart,
    img: imgPersonal,
    title: "Personal Care Services",
    tagline: "Dignified daily support at home",
    short:
      "Support with daily activities while preserving dignity and independence.",
    intro:
      "Our Personal Care Services help individuals with the everyday activities of daily living so they can remain safe, comfortable and independent in their own homes. Every client is treated with warmth and respect.",
    body: [
      "Our compassionate caregivers provide hands-on, tailored support that adapts to each client's routine and comfort level. From help getting ready in the morning to gentle reminders throughout the day, we focus on preserving dignity at every step.",
      "We work closely with families to build a care plan that reflects personal preferences, health needs and daily habits, ensuring consistent, respectful care that truly enhances quality of life.",
    ],
    included: [
      {
        icon: faListCheck,
        title: "Assistance with Daily Activities",
        text: "Help with mobility, transfers and everyday routines around the home.",
      },
      {
        icon: faBath,
        title: "Personal Hygiene Support",
        text: "Respectful help with bathing, grooming, dressing and toileting.",
      },
      {
        icon: faPills,
        title: "Medication Reminders",
        text: "Timely, friendly reminders to help clients stay on schedule.",
      },
      {
        icon: faShirt,
        title: "Dressing & Grooming",
        text: "Support choosing clothing and looking and feeling their best.",
      },
    ],
    helps:
      "Ideal for seniors and individuals recovering from illness or surgery who need a helping hand with daily routines while staying at home.",
  },
  {
    slug: "companion-care",
    icon: faPeopleGroup,
    img: imgCompanion,
    title: "Companion Care",
    tagline: "Friendly company that brightens each day",
    short: "Companionship and emotional support that eases loneliness.",
    intro:
      "Our Companion Care provides genuine companionship and emotional support, helping to ease loneliness while promoting social interaction that enhances overall well-being and quality of life.",
    body: [
      "A friendly, familiar face can make all the difference. Our caregivers spend meaningful time with clients, sharing conversations, hobbies and outings that keep spirits high and days engaging.",
      "Beyond company, we assist with light everyday tasks and safe transportation, so clients stay connected to the people, places and activities they love.",
    ],
    included: [
      {
        icon: faMugHot,
        title: "Engaging Social Activities",
        text: "Conversation, games, hobbies and shared meaningful moments.",
      },
      {
        icon: faCarSide,
        title: "Transportation for Outings",
        text: "Safe rides to appointments, errands and social visits.",
      },
      {
        icon: faBroom,
        title: "Light Housekeeping",
        text: "Tidying, laundry and keeping living spaces comfortable.",
      },
      {
        icon: faUsers,
        title: "Emotional Support",
        text: "A caring presence that reduces isolation and lifts mood.",
      },
    ],
    helps:
      "Perfect for individuals who live alone or feel isolated and would benefit from regular, friendly companionship and a little help around the house.",
  },
  {
    slug: "dementia-care",
    icon: faBrain,
    img: imgDementia,
    title: "Dementia Care",
    tagline: "Specialized, compassionate memory support",
    short:
      "Specialized, safe support for individuals living with dementia.",
    intro:
      "Our specialized Dementia Care offers a safe environment and personalized support for individuals living with dementia. Trained caregivers use engaging activities and calming routines to promote cognitive function and emotional well-being.",
    body: [
      "Caring for a loved one with dementia can be challenging. Our caregivers are trained in gentle, patient techniques that reduce confusion and anxiety while encouraging comfort and familiarity.",
      "We create structured, reassuring routines and meaningful activities that support memory and dignity, while keeping families informed and supported every step of the way.",
    ],
    included: [
      {
        icon: faPuzzlePiece,
        title: "Cognitive Engagement",
        text: "Memory-friendly activities that stimulate and reassure.",
      },
      {
        icon: faShieldHalved,
        title: "Safety Monitoring",
        text: "A watchful, calming presence to keep clients safe at home.",
      },
      {
        icon: faUsers,
        title: "Family Support Services",
        text: "Guidance and updates that give families peace of mind.",
      },
      {
        icon: faHouseUser,
        title: "Familiar Routines",
        text: "Consistent daily structure that eases confusion.",
      },
    ],
    helps:
      "Designed for individuals living with Alzheimer's or other forms of dementia, and for families seeking trusted, specialized in-home support.",
  },
  {
    slug: "life-care-services",
    icon: faHeartPulse,
    img: imgLife,
    title: "Life Care Services",
    tagline: "Holistic support for everyday living",
    short:
      "Holistic support to enhance daily living and independence.",
    intro:
      "Our Life Care Services focus on holistic support to enhance daily living. We work closely with clients and their families to build a care plan that promotes independence while ensuring safety and comfort.",
    body: [
      "Life Care brings together the practical and personal sides of care. From planning to daily tasks, we help clients maintain the lifestyle they value while staying safe and supported.",
      "Our caregivers assist with meals, errands and household needs, and coordinate care around each client's goals so everyday life stays comfortable and manageable.",
    ],
    included: [
      {
        icon: faListCheck,
        title: "Customized Care Planning",
        text: "A personalized plan built around goals and preferences.",
      },
      {
        icon: faUtensils,
        title: "Meal Preparation",
        text: "Nutritious, enjoyable meals prepared to taste and diet.",
      },
      {
        icon: faBagShopping,
        title: "Errand Running Services",
        text: "Groceries, prescriptions and everyday errands handled.",
      },
      {
        icon: faPersonWalking,
        title: "Independence Support",
        text: "Encouragement and help to keep clients active and engaged.",
      },
    ],
    helps:
      "Great for clients who want comprehensive, coordinated support that keeps daily life running smoothly while promoting independence.",
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
